import AFSCalculator from './AFSCalculator';
export default AFSCalculator;
